import React, { useRef } from 'react';
import { TextField, IconButton, InputAdornment, Box } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const CustomDateField = ({
    label,
    value,
    onChange,
    width = '300px',
    height = '40px'
}) => {
    const hiddenInputRef = useRef();

    const handleDateChange = (e) => {
        const raw = e.target.value; // yyyy-MM-dd format from input[type="date"]
        onChange(raw); // directly use the raw value
    };

    return (
        <Box position="relative" sx={{ width }}>
            <TextField
                label={label}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                placeholder="yyyy-MM-dd"
                InputLabelProps={{ shrink: true }}
                size="small"
                sx={{
                    height,
                    '& .MuiInputBase-root': {
                        height,
                        minHeight: height,
                        paddingRight: '40px'
                    },
                    '& input': {
                        height: '100%',
                        padding: '8px 10px'
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Box position="relative">
                                <input
                                    ref={hiddenInputRef}
                                    type="date"
                                    onChange={handleDateChange}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        opacity: 0,
                                        width: '32px',
                                        height: height, // from props
                                        minHeight: height,
                                        cursor: 'pointer',
                                    }}
                                />
                                <IconButton
                                    onClick={() =>
                                        hiddenInputRef.current?.showPicker
                                            ? hiddenInputRef.current.showPicker()
                                            : hiddenInputRef.current.click()
                                    }
                                    size="small"
                                >
                                    <CalendarTodayIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

export default CustomDateField;
